import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Layout from '../layouts';

const Routes = () => (
    <BrowserRouter>
        <Switch>
            <Route exact path="/:lang/parametricsearch/:pstId?" component={ Layout } />
            <Route path="/:pstId?" component={ Layout } />            
        </Switch>
    </BrowserRouter>
);

export default Routes;